<div class="iv">

  <!-- Loading -->
  @if (loadingList) {
    <div class="iv-center"><mat-spinner diameter="28" /></div>
  }

  @if (!loadingList && !verifications.length) {
    <p class="iv-empty">No identity verifications found.</p>
  }

  @if (!loadingList && verifications.length) {

    <!-- Top bar -->
    <div class="iv-topbar">

      <!-- Stats -->
      <div class="iv-stats">
        <span class="iv-stat">
          <b>{{ total }}</b> Total
        </span>
        <span class="iv-stat iv-stat--warn">
          <b>{{ last24h }}</b> Last 24h
        </span>
        <span class="iv-stat iv-stat--success">
          <b>{{ completed }}</b> Completed
        </span>
        <span class="iv-stat iv-stat--danger">
          <b>{{ rejected }}</b> Rejected
        </span>
        <span class="iv-stat iv-stat--primary">
          <b>{{ pending }}</b> Pending
        </span>
      </div>

      <!-- Nav + Start -->
      <div class="iv-nav">
        <button mat-icon-button [disabled]="currentIndex === 0" (click)="navigate(-1)">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="iv-nav__counter">{{ currentIndex + 1 }} / {{ total }}</span>
        <button mat-icon-button [disabled]="currentIndex === verifications.length - 1" (click)="navigate(1)">
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-stroked-button color="primary" (click)="startVerification()">
          <mat-icon>add</mat-icon> Start Verification
        </button>
      </div>

    </div>

    <!-- Case header -->
    @if (currentDetail) {
      <div class="iv-header">

        <span class="iv-id">#{{ currentDetail.id }}</span>

        <div class="iv-chip iv-chip--{{ statusClass(currentDetail.status) }}">
          <mat-icon class="iv-chip__icon">{{ STATUS_ICON[currentDetail.status] ?? 'help_outline' }}</mat-icon>
          {{ currentDetail.status }}
        </div>

        <span class="iv-meta">{{ currentDetail.flow }} · {{ currentDetail.brand }}</span>

        <div class="iv-header__right">
          <span class="iv-pill">{{ currentDetail.startedAt | date:'dd.MM.yyyy HH:mm' }}</span>
          <span class="iv-pill">⏱ {{ duration(currentDetail.startedAt, currentDetail.endedAt) }}</span>
          @if (currentDetail.miReportId) {
            <span class="iv-pill">MI #{{ currentDetail.miReportId }}</span>
          }
          <div class="iv-sep"></div>
          <button class="iv-btn iv-btn--reject"   (click)="decide('reject')">Reject</button>
          <button class="iv-btn iv-btn--approve"  (click)="decide('approve')">Approve</button>
        </div>

      </div>
    }

    @if (loadingDetail) {
      <div class="iv-center iv-center--sm"><mat-spinner diameter="24" /></div>
    }

    <!-- Body -->
    @if (!loadingDetail && currentDetail) {
      <div class="iv-body">

        <!-- Events (left, scrollable) -->
        <div class="iv-events-col">
          <span class="iv-label">Events</span>
          <div class="iv-timeline">
            @for (ev of eventsDesc; track ev.id; let last = $last) {
              <div class="iv-event" [class.iv-event--last]="last">

                <div class="iv-event__dot" [style.background]="
                  isFailEvent(ev.type)    ? '#e53935' :
                  isSuccessEvent(ev.type) ? '#43a047' :
                  procColor(ev.processor)">
                </div>

                <span class="iv-event__type"
                      [class.iv-event__type--fail]="isFailEvent(ev.type)"
                      [class.iv-event__type--ok]="isSuccessEvent(ev.type)">
                  {{ ev.type.split('_').join(' ') }}
                </span>

                <span class="iv-proc-tag"
                      [style.background]="procColor(ev.processor) + '1a'"
                      [style.color]="procColor(ev.processor)">
                  {{ ev.processor }}
                </span>

                <span class="iv-mono iv-muted">
                  {{ ev.ts | date:'HH:mm:ss' }}
                  @if (relTime(currentDetail.events[0].ts, ev.ts)) {
                    <span class="iv-rel">{{ relTime(currentDetail.events[0].ts, ev.ts) }}</span>
                  }
                </span>

              </div>
            }
          </div>
        </div>

        <!-- Documents + Session (right) -->
        <div class="iv-right-col">

          <!-- Document matrix -->
          <div>
            <div class="iv-section-head">
              <span class="iv-label">Documents</span>
              <div class="iv-chip iv-chip--{{ statusClass(consolidatedDocStatus) }}">
                <mat-icon class="iv-chip__icon">{{ STATUS_ICON[consolidatedDocStatus] ?? 'help_outline' }}</mat-icon>
                {{ consolidatedDocStatus }}
              </div>
            </div>

            <div class="iv-matrix">
              @for (row of DOC_ROWS; track row.label) {
                <div class="iv-matrix__row" [class.iv-matrix__row--rejected]="currentDetail[row.statusKey] === 'REJECTED'">
                  <div class="iv-dot iv-dot--{{ statusClass(currentDetail[row.statusKey]) }}">
                    <mat-icon>{{ STATUS_ICON[currentDetail[row.statusKey]] ?? 'help_outline' }}</mat-icon>
                  </div>
                  <span class="iv-matrix__label">{{ row.label }}</span>
                  <span class="iv-matrix__reason" [class.iv-matrix__reason--fail]="currentDetail[row.reasonKey]">
                    {{ currentDetail[row.reasonKey] ?? '—' }}
                  </span>
                  @if (currentDetail[row.docKey]) {
                    <span class="iv-mono iv-muted">doc#{{ currentDetail[row.docKey] }}</span>
                  }
                </div>
              }
            </div>
          </div>

        </div>

        <!-- Session sidebar -->
        <div class="iv-sidebar">
          <span class="iv-label">Session</span>
          <div class="iv-field">
            <span>Started</span>  <span>{{ currentDetail.startedAt | date:'dd.MM.yyyy HH:mm' }}</span>
          </div>
          <div class="iv-field">
            <span>Ended</span>    <span>{{ (currentDetail.endedAt | date:'dd.MM.yyyy HH:mm') ?? '—' }}</span>
          </div>
          <div class="iv-field">
            <span>Duration</span> <span>{{ duration(currentDetail.startedAt, currentDetail.endedAt) }}</span>
          </div>
          <div class="iv-field">
            <span>Flow</span>     <span class="iv-mono">{{ currentDetail.flow }}</span>
          </div>
          <div class="iv-field">
            <span>Brand</span>    <span>{{ currentDetail.brand }}</span>
          </div>
        </div>

      </div>
    }

  }

</div>